import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import React from 'react';
import WindowPanel from '../../../../../../modal/Window';
import Icon from '../../../../../Icon';
import { Typography, DialogContent, Grid, List, ListItem, ListItemIcon, ListItemText, TextField, MenuItem, withStyles } from '@material-ui/core';
var formatsDefinition = [{
  name: 'None',
  icon: 'alphabetical'
}, {
  name: 'Number',
  icon: 'number-format',
  options: [{
    format: 'number:#,###.#',
    name: 'US Number',
    example: '1,234.5'
  }, {
    format: 'number:#.###,#',
    name: 'Europe Number',
    example: '1.234,5'
  }]
}, {
  name: 'Currency',
  icon: 'currency-format',
  options: [{
    format: 'currency:$#,##0.00',
    name: 'US Currency',
    example: '$1,234.56'
  }, {
    format: 'currency:#.##0,00€',
    name: 'Europe Currency',
    example: '1.234,56€'
  }, {
    format: 'currency:£#,##0.00',
    name: 'UK Currency',
    example: '£1,234.56'
  }]
}, {
  name: 'Date/Time',
  icon: 'date-format',
  options: [{
    format: 'date:MM/dd/yyyy',
    name: 'Short Date',
    example: '08/13/2011'
  }, {
    format: 'date:MMMM dd, yyyy',
    name: 'Long Date',
    example: 'August 13, 2011'
  }, {
    format: 'date:MM/dd/yyyy hh:mm:ss a',
    name: 'Date and Time',
    example: '08/13/2011 08:17:46 PM'
  }]
}, {
  name: 'Custom',
  icon: 'style'
}];

var getFormatTypeIndex = function getFormatTypeIndex(format) {
  if (!format) return 0;
  var formatTypeIndex = formatsDefinition.findIndex(function (formatTypeInfo) {
    if (formatTypeInfo.options) return formatTypeInfo.options.some(function (option) {
      return option.format === format;
    });
    return false;
  });
  if (formatTypeIndex === -1) return formatsDefinition.length - 1;
  return formatTypeIndex;
};

var FormatDialog =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FormatDialog, _React$Component);

  function FormatDialog(props) {
    var _this;

    _classCallCheck(this, FormatDialog);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FormatDialog).call(this));

    _this.handleListItemClick = function (event, index) {
      _this.setState({
        formatTypeIndex: index
      });

      if (formatsDefinition[index].options) {
        _this.setState({
          format: formatsDefinition[index].options[0].format
        });
      } else if (index === 0) {
        _this.setState({
          format: ''
        });
      }
    };

    _this.handleFormatChanged = function (event) {
      _this.setState({
        format: event.target.value
      });
    };

    _this.onOK = function () {
      _this.props.onChange(_this.state.format);
    };

    _this.state = {
      formatTypeIndex: getFormatTypeIndex(props.value),
      format: props.value
    };
    return _this;
  }

  _createClass(FormatDialog, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          onClose = _this$props.onClose,
          classes = _this$props.classes,
          theme = _this$props.theme;
      var _this$state = this.state,
          formatTypeIndex = _this$state.formatTypeIndex,
          format = _this$state.format;
      var currentFormatTypeInfo = formatsDefinition[formatTypeIndex];
      return React.createElement(WindowPanel, {
        style: {
          width: 600
        },
        onClose: onClose,
        header: "Format",
        content: React.createElement(DialogContent, null, React.createElement(Grid, {
          container: true,
          spacing: 4
        }, React.createElement(Grid, {
          item: true,
          xs: 5
        }, React.createElement(List, {
          component: "nav"
        }, formatsDefinition.map(function (formatGroup, index) {
          return React.createElement(ListItem, {
            key: formatGroup.name,
            button: true,
            classes: {
              root: classes.listItemRoot,
              selected: classes.listItemRootSelected
            },
            className: classes.listItem,
            selected: formatTypeIndex === index,
            onClick: function onClick(event) {
              return _this2.handleListItemClick(event, index);
            }
          }, React.createElement(ListItemIcon, {
            className: classes.tabIconItemRoot
          }, React.createElement(Icon, {
            size: "small",
            className: classes.tabIcon,
            type: formatGroup.icon
          })), React.createElement(ListItemText, {
            primary: formatGroup.name
          }));
        }))), React.createElement(Grid, {
          item: true,
          xs: true
        }, currentFormatTypeInfo.name === 'None' && React.createElement(Typography, null, "No format. This will clear the format of the current field."), currentFormatTypeInfo.name === 'Number' && React.createElement(TextField, {
          label: "Format",
          fullWidth: true,
          value: format,
          onChange: this.handleFormatChanged,
          select: true
        }, currentFormatTypeInfo.options.map(function (option) {
          return React.createElement(MenuItem, {
            key: option.format,
            value: option.format,
            className: classes.menuItem
          }, React.createElement(ListItemText, {
            primary: option.name,
            secondary: option.example
          }));
        })), currentFormatTypeInfo.name === 'Currency' && React.createElement(TextField, {
          label: "Format",
          fullWidth: true,
          value: format,
          onChange: this.handleFormatChanged,
          select: true
        }, currentFormatTypeInfo.options.map(function (option) {
          return React.createElement(MenuItem, {
            key: option.format,
            value: option.format,
            className: classes.menuItem
          }, React.createElement(ListItemText, {
            primary: option.name,
            secondary: option.example
          }));
        })), currentFormatTypeInfo.name === 'Date/Time' && React.createElement(TextField, {
          label: "Format",
          fullWidth: true,
          select: true,
          value: format,
          onChange: this.handleFormatChanged
        }, currentFormatTypeInfo.options.map(function (option) {
          return React.createElement(MenuItem, {
            key: option.format,
            value: option.format,
            className: classes.menuItem
          }, React.createElement(ListItemText, {
            primary: option.name,
            secondary: option.example
          }));
        })), currentFormatTypeInfo.name === 'Custom' && React.createElement(TextField, {
          label: "Format",
          fullWidth: true,
          onChange: this.handleFormatChanged,
          value: format,
          placeholder: "date:mm/dd/YYYY"
        })))),
        footerButtons: {
          submit: {
            children: 'OK',
            onClick: this.onOK
          }
        }
      });
    }
  }]);

  return FormatDialog;
}(React.Component);

FormatDialog.defaultProps = {
  value: ''
};
var styles = {
  tabIconItemRoot: {
    marginRight: 0
  },
  tabIcon: {
    fontSize: 14
  },
  menuItem: {
    height: 'auto'
  },
  listItemRoot: {
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.1)'
    },
    '&$listItemRootSelected': {
      backgroundColor: 'rgba(0, 0, 0, 0.1)',
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.1)'
      }
    }
  },
  listItemRootSelected: {}
};
export default withStyles(styles, {
  withTheme: true,
  name: 'ECFormatDialog'
})(FormatDialog);